/* -disable react/no-unused-state */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

import Filters from '../../components/Filters';
import { getFiltersOptions } from '../../../../redux/operational-dashboard-configuration';
import './styles.css';
import ProgressBar from '../../../../components/ProgressBar';

const FILTERS = {
  DISTRIBUCTION_CENTERS: 'filialId',
  DATE: 'date',
  CLIENTS: 'companyId',
};
const EMPTY_FILTER_MESSAGE = {
  DISTRIBUCTION_CENTER: 'Todos os Centros de Dristibuição',
  DATE: 'Hoje',
  CLIENT: 'Todos os Clientes',
};

class FiltersBar extends React.Component {
  state = {
    currentOpenedFilter: false,
    distribuctionCenterFilterLabel: EMPTY_FILTER_MESSAGE.DISTRIBUCTION_CENTER,
    dateFilterLabel: EMPTY_FILTER_MESSAGE.DATE,
    clientFilterLabel: EMPTY_FILTER_MESSAGE.CLIENT,
    progressBarState: 100,
    progressTime: 300000,
    shouldReloadFilters: false,
  };

  async componentDidMount() {
    await this.props.getFiltersOptions();
    this._updateFiltersLabel();
    this.interval = this.controlProgressBar();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this._onRouteChange();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  controlProgressBar() {
    const interval = setInterval(() => {
      const { progressTime } = this.state;
      this.setState(prevState => ({
        progressBarState:
          progressTime === 0 ? 100 : prevState.progressBarState - 0.33,
        progressTime:
          progressTime === 0 ? 300000 : prevState.progressTime - 1000,
        shouldReloadFilters: progressTime === 0,
      }));
    }, 1000);
    return interval;
  }

  _renderFormattedCounter = () => {
    let counterMinutes = moment
      .duration(this.state.progressTime)
      .minutes()
      .toString();
    let counterSeconds = moment
      .duration(this.state.progressTime)
      .seconds()
      .toString();

    if (counterMinutes.length === 1) {
      counterMinutes = `0${counterMinutes}`;
    }

    if (counterSeconds.length === 1) {
      counterSeconds = `0${counterSeconds}`;
    }

    return `${counterMinutes}:${counterSeconds}`;
  };

  _onRouteChange = () => {
    this._updateFiltersLabel();
  };

  _updateFiltersLabel = () => {
    this.setState({
      distribuctionCenterFilterLabel: this._getFilterLabel(
        this._getSearchParamFromUrl(FILTERS.DISTRIBUCTION_CENTERS),
        FILTERS.DISTRIBUCTION_CENTERS,
        EMPTY_FILTER_MESSAGE.DISTRIBUCTION_CENTER,
      ),
      clientFilterLabel: this._getFilterLabel(
        this._getSearchParamFromUrl(FILTERS.CLIENTS),
        FILTERS.CLIENTS,
        EMPTY_FILTER_MESSAGE.CLIENT,
      ),
      dateFilterLabel: this._getFilterLabel(
        this._getSearchParamFromUrl(FILTERS.DATE, false),
        FILTERS.DATE,
        EMPTY_FILTER_MESSAGE.DATE,
      ),
    });
  };

  _getLabel = (currentValue, sourceFilter) => {
    // -disable-next-line eqeqeq
    const result = sourceFilter.find(item => item.value == currentValue);

    return result.label;
  };

  _getFilterLabel = (selectedItens, filterName, emptyFilterLabel) => {
    const sourceFilter = this.props[filterName];
    if (
      (Array.isArray(sourceFilter) && sourceFilter.length === 0) ||
      (Array.isArray(selectedItens) && selectedItens.length === 0)
    ) {
      return emptyFilterLabel;
    }

    if (typeof selectedItens === 'string') {
      return moment(selectedItens).format('DD/MM/YYYY');
    }

    if (!selectedItens) return emptyFilterLabel;

    return selectedItens.reduce(
      (acumulator, currentValue) =>
        acumulator +
        (!acumulator ? '' : ' - ') +
        this._getLabel(currentValue, sourceFilter),
      '',
    );
  };

  _queryStringToObject = queryString => {
    const pairs = queryString.slice(1).split('&');
    const result = {};
    pairs.forEach(pair => {
      result[pair.split('=')[0]] = pair.split('=')[1] || '';
    });

    return result;
  };

  _objectToQueryString = object =>
    Object.keys(object)
      .map(key => `${key}=${object[key]}`)
      .join('&');

  _getFilterType = path => path.slice(25);

  _getSearchParamFromUrl = (paramName, split = true) => {
    const params = new URLSearchParams(
      decodeURIComponent(this.props.location.search),
    );
    const param = params.get(paramName);

    if (split) {
      const splitedParam = param ? param.split(',') : [];

      return splitedParam;
    }

    return param;
  };

  _setSearchParamInUrl = (paramName, values) => {
    const { onFilter } = this.props;

    this._toggleFilter(false);
    const params = this.props.location.search
      ? this._queryStringToObject(this.props.location.search)
      : {};
    if (
      (Array.isArray(values) && values.length === 0) ||
      !values ||
      values === ''
    ) {
      delete params[paramName];
    } else {
      params[paramName] = encodeURIComponent(values);
    }
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: this._objectToQueryString(params),
    });
    const type = this._getFilterType(this.props.location.pathname);

    onFilter(type, params);
    // window.location.reload();
  };

  _toggleFilter = filter => {
    let newFilter = filter;

    if (this.state.currentOpenedFilter === newFilter) {
      newFilter = false;
    }

    this.setState({
      currentOpenedFilter: newFilter,
    });
  };

  render() {
    const {
      currentOpenedFilter,
      distribuctionCenterFilterLabel,
      dateFilterLabel,
      clientFilterLabel,
      progressBarState,
    } = this.state;
    const { filialId, companyId } = this.props;

    return (
      <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
        <div className="OperationalDashboard_Filters">
          {!!currentOpenedFilter && (
            <div
              className="FiltersContainer__Overlay"
              onClick={() => this._toggleFilter(false)}
            />
          )}
          <Filters
            submitText="Filtrar"
            type="select"
            dropdownLabel="Centros de Distribuição"
            placeholder="Selecione os Centros de Distribuição"
            filterLabel={distribuctionCenterFilterLabel}
            current={this._getSearchParamFromUrl(FILTERS.DISTRIBUCTION_CENTERS)}
            onClick={() => this._toggleFilter(FILTERS.DISTRIBUCTION_CENTERS)}
            onFilter={selectedValues =>
              this._setSearchParamInUrl(
                FILTERS.DISTRIBUCTION_CENTERS,
                selectedValues,
              )
            }
            isOpen={currentOpenedFilter === FILTERS.DISTRIBUCTION_CENTERS}
            options={filialId}
          />
          <Filters
            type="datepicker"
            dropdownLabel="Data"
            placeholder="Selecione a data"
            filterLabel={dateFilterLabel}
            submitText="Filtrar"
            current={this._getSearchParamFromUrl(FILTERS.DATE, false)}
            onClick={() => this._toggleFilter(FILTERS.DATE)}
            isOpen={currentOpenedFilter === FILTERS.DATE}
            onFilter={value => this._setSearchParamInUrl('date', value)}
          />
          <Filters
            submitText="Filtrar"
            placeholder="Selecione os Clientes"
            filterLabel={clientFilterLabel}
            dropdownLabel="Clientes"
            current={this._getSearchParamFromUrl(FILTERS.CLIENTS)}
            onClick={() => this._toggleFilter(FILTERS.CLIENTS)}
            onFilter={selectedValues =>
              this._setSearchParamInUrl(FILTERS.CLIENTS, selectedValues)
            }
            isOpen={currentOpenedFilter === FILTERS.CLIENTS}
            type="select"
            options={companyId}
          />
        </div>
        <div>
          <div
            style={{
              marginTop: 8,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            <div>Próxima atualização em: {this._renderFormattedCounter()}</div>
            <ProgressBar
              completed={progressBarState}
              style={{
                width: 'auto',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

FiltersBar.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = state => ({
  companyId: state.operationalDashboardConfiguration.clients,
  filialId: state.operationalDashboardConfiguration.distribuctionCenters,
});

export default withRouter(
  connect(mapStateToProps, {
    getFiltersOptions,
  })(FiltersBar),
);
